// extracted by mini-css-extract-plugin
export default {"GiftDetailsDrawer":"GiftDetailsDrawer-styles__GiftDetailsDrawer__wKMae","GiftDetailsDrawer__Section":"GiftDetailsDrawer-styles__GiftDetailsDrawer__Section__X_lIn"};